import { ReactElement, useContext } from "react"

import { SYS_ADMIN_LCT_STEPS } from "../../../../../constants/lct/evac/deviceForm"
import AppStepper from "../../../../dataDisplay/stepper/appStepper"
import { NON_SYS_ADMIN_HP_STEPS } from "../../formSpecs/hpSpec"
import { CreateHpDeviceContext } from "../providers/baseProviders/createHpDeviceProvider"

/** AppStepper for EVDC device creation
 */
const CreateHpDeviceProgressStepper = (): ReactElement => {
    const { currentIndex, canEditManufacturer } = useContext(
        CreateHpDeviceContext
    )

    const steps = canEditManufacturer
        ? [...SYS_ADMIN_LCT_STEPS, ...NON_SYS_ADMIN_HP_STEPS]
        : NON_SYS_ADMIN_HP_STEPS

    return <AppStepper stepLabels={steps} currentStepIndex={currentIndex} />
}

export default CreateHpDeviceProgressStepper
